import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { EDIT_WAREHOUSE } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import { getCities, getCountries, getStates } from "../utils/country";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";

const useEditWarehouse = ({ rowData, refetch }) => {
  let countries = getCountries();

  let selected_country = countries.find(
    (item) => item.value === rowData?.address?.country
  );
  let selected_state = getStates(selected_country?.country_id).find(
    (item) => item.value === rowData?.address?.state
  );
  let selected_city = getCities(
    selected_country?.country_id,
    selected_state?.state_id
  ).find((item) => item.value === rowData?.address?.city);

  const defaultValues = {
    id: rowData?.id,
    name: rowData?.name ?? "",
    phone: rowData?.phone ?? "",
    store_id: getSelectedStoreDetails("id"),
    address: {
      zip: rowData?.address?.zip,
      address: rowData?.address?.address,
      country: selected_country,
      state: selected_state,
      city: selected_city,
    },
  };

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit, { loading }] = useMutation(EDIT_WAREHOUSE);

  const country = watch("address.country");
  const state = watch("address.state");

  const resetField = (field) => setValue(field, "");

  useEffect(() => {
    if (rowData) {
      reset(defaultValues);
    }
  }, [rowData]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        address: {
          ...data.address,
          address: data?.address?.address ?? "",
          country: data?.address?.country.value ?? "",
          city: data?.address?.city.value ?? "",
          state: data?.address?.state.value ?? "",
        },
      };

      delete payload.store_id;

      await submit(payloadValidator(payload));
      reset(defaultValues);
      refetch();
      closeModal("edit-units");
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    closeModal("edit-units");
  };

  return {
    values: {
      control,
      errors,
      loading,
      setValue,
      countries,
      states: country ? getStates(country?.country_id) : [],
      cities:
        country && state ? getCities(state.country_id, state.state_id) : [],
    },
    functions: {
      onSubmit: handleSubmit(onSubmit),
      onCancel,
      resetField,
    },
  };
};

export default useEditWarehouse;
